module.exports = __webpack_public_path__ + "img/6_3.2a59356a.png";